import breakpoints from '@/scripts/utils/_breakpoints';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

export const getDates = form => ((form.dataset.type === 'inline' && window.innerWidth > breakpoints.lg) ? null : ['today', new Date().fp_incr(1)]);

export default function initCustomDatepicker(el, form) {
  return flatpickr(el, {
    mode: 'range',
    minDate: 'today',
    altInput: true,
    altFormat: 'j F, Y',
    dateFormat: 'Y-m-d',
    defaultDate: getDates(form),
    static: true,
    locale: {
      firstDayOfWeek: 1,
    },
  });
}



// WEBPACK FOOTER //
// ./scripts/utils/initCustomDatepicker.js